function init() {
	setGlobalVariables();
	headerVisibility();
}

function setGlobalVariables(){

	setContainerMarginVariable();
	setRealVhValue();

	window.addEventListener('resize', () => {
		
		setContainerMarginVariable();
		setRealVhValue();
		
	});

}

function setContainerMarginVariable(){

	var container = document.querySelector('.container');
	if(container){
		var style = container.currentStyle || window.getComputedStyle(container),
			marginLeft = style.marginLeft,
			width = style.width;

		if(!marginLeft){
			marginLeft = 0;
		}

		document.documentElement.style.setProperty('--smx-container-margin', `${marginLeft}`);
		document.documentElement.style.setProperty('--smx-container-margin-nagative', `-${marginLeft}`);
		document.documentElement.style.setProperty('--smx-container-width', `${width}`);
	}

}

function setRealVhValue(){
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function headerVisibility() {
	var mainHeader = document.getElementById("main-header");

	window.addEventListener("scroll", function () {
		var scrollTop = document.documentElement.scrollTop;
		if (scrollTop >= 150) {
			mainHeader.classList.add("scrolled");
		} else {
			mainHeader.classList.remove("scrolled");
		}
	});

	var lastScrollTop = 0;

	window.addEventListener(
		"scroll",
		function () {
			var scrollTop = document.documentElement.scrollTop;

			if (scrollTop >= 150) {
				mainHeader.classList.add("scrolled");
				mainHeader.addEventListener(
					"transitionend",
					function () {
						if (!mainHeader.classList.contains("has-scrolled")) {
							mainHeader.classList.add("has-scrolled");
						}
					},
					{
						once: true,
					}
				);
			} else {
				mainHeader.classList.remove("scrolled");
				mainHeader.addEventListener(
					"transitionend",
					function () {
						if (mainHeader.classList.contains("has-scrolled")) {
							mainHeader.classList.remove("has-scrolled");
						}
					},
					{
						once: true,
					}
				);
			}

			if (scrollTop < lastScrollTop) {
				mainHeader.classList.add("scroll-up");
				document.body.classList.add("scroll-up");
			} else {
				mainHeader.classList.remove("scroll-up");
				document.body.classList.remove("scroll-up");
			}

			lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
		},
		false
	);
}

export default { init };